import { UserInviteFormValues, UserInvite, APIClientInterface, ListResponse, SingleResponse, UserInviteServiceInterface, UserInviteListItem } from '../types'

export default class UserInvitesService implements UserInviteServiceInterface {
	constructor(private client: APIClientInterface) {}

	public async getAll(): Promise<ListResponse<UserInviteListItem>> {
		return this.client.get(`/invites`)
	}

	public async create(values: UserInviteFormValues): Promise<SingleResponse<UserInvite>> {
		return this.client.post(`/invites`, JSON.stringify(values))
	}

	public async get(token: string): Promise<SingleResponse<UserInvite>> {
		return this.client.get(`/invites/${token}`)
	}

	public async claim(token: string, values: Record<string, string>): Promise<SingleResponse<UserInvite>> {
		return this.client.post(`/invites/${token}`, JSON.stringify(values))
	}

	public async delete(email: string): Promise<void> {
		return this.client.delete(`/invites/${encodeURIComponent(email)}`)
	}
}
